import { useSetState } from 'ahooks';
import { SetState } from 'ahooks/lib/useSetState';
import { PropsWithChildren } from 'react';
import { IndustryRankRequest, RecoverRankRequest } from 'services/api/dashboard';
import createNamedContext from 'utils/createNamedContext';

export interface TrendDrawerType {
  visible: boolean;
  /**
   * rank: 行业排名
   * recover: 订单挽回
   */
  type: 'rank' | 'recover';
  params: Partial<
    Omit<Omit<IndustryRankRequest & RecoverRankRequest, 'regions'>, keyof Dashboard.BasicParams>
  >;
  setTrendValue: SetState<Omit<TrendDrawerType, 'setTrendValue'>>;
}

export const TrendDrawerContext = createNamedContext<TrendDrawerType | null>(
  'TrendDrawerContext',
  null,
);

interface TrendProviderProps {}
function TrendProvider(props: PropsWithChildren<TrendProviderProps>) {
  const { children } = props;
  const [trend, setTrendValue] = useSetState<Omit<TrendDrawerType, 'setTrendValue'>>({
    type: 'rank',
    visible: false,
    params: {},
  });

  return (
    <TrendDrawerContext.Provider value={{ ...trend, setTrendValue }}>
      {children}
    </TrendDrawerContext.Provider>
  );
}
export default TrendProvider;
